<template>
  <div>
    <b-card>
      <b-row class="temp_mapping">
        <b-col cols="8" class="text-left">
          <h4>{{ $t('Validations') }}</h4>
        </b-col>
        <b-col cols="4" class="text-right">
          <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.customValidation >
            <i class="fa fa-plus"> </i> <span> {{ $t('Add new validation') }} </span>
          </b-button>
          <b-button type="submit" size="sm" variant="secondary" class="mt-0" v-b-modal.importValidations >
            <i class="fa fa-upload"> </i> <span> {{ $t('Import validations') }} </span>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col cols="6" v-for="validation in externalServiceValidations" :key="validation.id" >
        <b-card>
          <b-card border-variant="info" align="left">
            <div slot="header">
                <b-row>
                  <b-col md="8">
                    <h5>Validation</h5>
                  </b-col>
                  <b-col md="4">
                    <div class="float-right add-field-btn">
                      <b-button type="submit" size="sm" variant="primary" class="mt-0" @click="editExternalServiceValidation(validation.template_doc_id)"><i class="fa fa-edit"></i></b-button>
                      <b-button type="submit" size="sm" variant="danger" class="mt-0" @click="showDeleteModal(validation.template_doc_id)"><i class="fa fa-trash"></i></b-button>
                    </div>
                  </b-col>
                </b-row>
              </div>
            <p class="card-text">
              <b-row >
                <b-col cols="4">Template:</b-col>
                <b-col cols="8 text-left">{{validation.template}}</b-col>
              </b-row>
            </p>
          </b-card>
        </b-card>
      </b-col>
    </b-row>
    <!-- Custom Validation Modal -->
    <b-modal id="customValidation" size="lg" class="external-service-validation-modal" :title="extServiceValidation.created ? 'New Validation' : 'Edit Validation'" hide-footer header-bg-variant="light" ref="externalServiceValidationModal" @hidden="onHidingExtSerValModal">
      <b-row>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Template:</b-col>
              <b-col cols="7 text-left">
                <model-select class="modelSelect" :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" placeholder="Select Template"></model-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showVersionsRow">
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Page:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplate" :options="availableTemplates" @change="fetchTemplateVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Version:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplateVersion" :options="availableTemplateVersions" @change="handleSelectedVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showFetchButton">
        <b-col cols="8 text-left">
          <b-btn size="sm" class="float-right" @click="fetchValidations" variant="secondary mr-1"  :disabled="!(templateDoc.selectedTemplateDocId && selectedTemplate && selectedTemplateVersion)" >Fetch</b-btn>
        </b-col>
      </b-row>
      <b-row v-if="showESV">
        <b-col cols="12">
          <b-card border-variant="info"
                          align="left" >
                      <div slot="header">
                        <b-row style="margin: 0px">
                          <b-col md="10">
                            <h6 style="margin: 1px 0px 0px 0px">Edit Validation</h6>
                          </b-col>
                          <b-col md="2">
                            <i class="fa fa-download download-efm fa-lg" @click="downloadCsvalidations" v-b-tooltip.hover title='Download ExternalValidations'></i>
                          </b-col>
                        </b-row>
                      </div>
            </b-card>
          <b-card border-variant="info"
            align="left">
            <p class="card-text">
              <b-row>
                <b-col cols="4">
                  <b-col>
                    <label>Validation Name</label>
                    <b-form-input :plain="true" v-model="editValidationName"></b-form-input>
                  </b-col>
                  <b-col>
                    <label>Error Message</label>
                    <b-form-input :plain="true" v-model="editErrorMessage"></b-form-input>
                  </b-col>
                  <b-col>
                      <input type="checkbox"v-model="isOptional">
                      <label>Optional Validation</label>
                  </b-col>
                </b-col>
                <b-col cols="8">
                  <label>Rules</label>
                  <b-form-textarea placeholder="Rules" rows="4" v-model="editRule">
                  </b-form-textarea>
                </b-col>
              </b-row>
            </p>
              <b-row>
                <b-col align="center">
                  <b-btn size="sm" @click="clearValidations" variant="secondary mr-1"  :disabled="!(templateDoc.selectedTemplateDocId && selectedTemplate && selectedTemplateVersion)" >Clear</b-btn>
                  <b-btn size="sm" v-on:click="saveValidations" variant="secondary mr-1"  :disabled="!(editValidationName && editErrorMessage)" >Save</b-btn>
                </b-col>
              </b-row>
          </b-card>
        </b-col>
        <b-col cols="6" v-for="(validation, index) in this.customValidations" :key="validation.id" >
          <b-card>
            <b-card border-variant="info" align="left">
              <div slot="header">
                  <b-row>
                    <b-col md="8">
                      <h5>{{validation.validation_name}}</h5>
                    </b-col>
                    <b-col md="4">
                      <div class="float-right add-field-btn">
                        <b-btn size="sm" style="padding: 1px 10px; border-radius: 10px" @click="editCustomValidation(index, validation)" variant="secondary" ><i class="fa fa-edit"> </i></b-btn>
                        <b-btn size="sm" style="padding: 1px 10px; border-radius: 10px" @click="deleteCustomValidation(validation.id)" variant="secondary" ><i class="fa fa-trash"> </i></b-btn>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              <p class="card-text">
                <b-col>
                  <label>Error Message</label>
                  <b-form-input :plain="true" readonly v-model="validation.error_message"></b-form-input>
                </b-col>
                <b-col>
                  <label>Rules</label>
                  <b-form-textarea placeholder="Rules" readonly rows="4" v-model="validation.rules">
                  </b-form-textarea>
                </b-col>
              </p>
            </b-card>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="importValidations" size="lg" class="external-service-validation-modal" title="Import Validations" hide-footer header-bg-variant="light" ref="externalCustomImportValidationModal" @hidden="onHidingExtSerValModal">
      <b-row>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Template:</b-col>
              <b-col cols="7 text-left">
                <b-form-select class="modelSelect" :plain="true" v-model="templateDoc.selectedTemplateDocId" :options="availableTemplateDocs" placeholder="Select Template"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-if="showVersionsRow">
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Page:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplate" :options="availableTemplates" @change="fetchTemplateVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
          <b-card>
            <b-row>
              <b-col cols="5">Select Version:</b-col>
              <b-col cols="7 text-left">
                <b-form-select :plain="true" v-model="selectedTemplateVersion" :options="availableTemplateVersions" @change="handleSelectedVersion"></b-form-select>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="6">
            <b-row>
              <b-col cols="4">Select File:</b-col>
              <b-col cols="8 text-left">
                <input id="fileUpload" type="file" ref="file" v-on:change="handleFileUpload()">
              </b-col>
            </b-row>
          </b-col>
      </b-row>
      <br>
      <b-row>
          <b-col cols="4"/>
          <div>
            <b-btn size="sm" variant="secondary" @click="saveImportValidations" :disabled="!isFileSelected"> {{ $t('CONFIGURED.CREATE') }} </b-btn>
            <b-btn size="sm" variant="light" @click="hideImportValidations"> {{ $t('COMMON.CLOSE') }} </b-btn>
          </div>
        </b-row>
    </b-modal>
    <!-- Delete Confirm Modal -->
    <b-modal centered
    id="deleteModal"
    ref="deleteModal"
    :title="$t('COMMON.DELETE_CONFIRM')"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    :ok-title="$t('COMMON.DELETE')"
    :cancel-title="$t('COMMON.CANCEL')"
    ok-variant="secondary"
    cancel-variant="light"
    @cancel="cancel"
    @keydown.native.enter="deleteExternalServiceValidation"
    @ok="deleteExternalServiceValidation" >
    <div class="delete-warning">
      <p>{{$t('COMMON.DEL_CUSTOMVALIDATION')}}</p>
    </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import router from '../../router'
import { ModelSelect } from 'vue-search-select'

export default {
  data () {
    return {
      externalServiceValidations: [],
      availableTemplateDocs: [],
      availableTemplates: [],
      availableTemplateVersions: [],
      selectedTemplate: null,
      selectedTemplateVersion: null,
      showVersionsRow: false,
      showFetchButton: false,
      showESV: false,
      template_doc_id: null,
      extServiceValidation: {
        created: true
      },
      isFileSelected: false,
      templateDoc: {
        selectedTemplateDocId: null,
        tmpFields: []
      },
      externalServiceValidation: {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      },
      customValidations: [],
      isEditValidation: false,
      editRule: '',
      editValidationName: '',
      editErrorMessage: '',
      editedValidation: null,
      isOptional: false
    }
  },
  components: {
    ModelSelect
  },
  computed: {
    ...mapGetters(['idToken', 'selectedRolesData', 'isAdminRole', 'accountId'])
  },
  watch: {
    'templateDoc.selectedTemplateDocId': function () {
      this.resetData(true)
      this.fetchData(this.templateDoc.selectedTemplateDocId)
    }
  },
  created () {
    let vm = this
    Vue.axios.get('/settings/custom_validations', { headers: { Authorization: `Bearer ${vm.idToken}` } })
      .then(res => {
        vm.externalServiceValidations = res.data.external_service_validations
        vm.availableTemplateDocs = [].concat(res.data.available_templates)
      })
      .catch(error => {
        if (error.status === 401) {
          console.log(this.$t('COMMON.MSG_EXPIRED'))
        } else {
          Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
        }
      })
  },
  methods: {
    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
      this.isFileSelected = true
      const reader = new window.FileReader()
      reader.onload = evt => {
        try {
          this.text = JSON.parse(evt.target.result)
        } catch (error) {
          this.isFileSelected = false
          Vue.toasted.show(this.$t('COMMON.FILE_ERROR'), { icon: 'chain-broken', type: 'error' })
          return
        }
        let payload = {
          template_doc_id: this.templateDoc.selectedTemplateDocId,
          template_id: this.selectedTemplate,
          revision_id: this.selectedTemplateVersion,
          validation_data: this.text
        }
        this.validationPayload = payload
      }
      reader.readAsText(this.file)
    },
    hideImportValidations () {
      this.$refs.externalCustomImportValidationModal.hide()
    },
    clearValidations () {
      this.editRule = null
      this.editValidationName = null
      this.editErrorMessage = null
      this.isEditValidation = false
      this.isOptional = false
    },
    saveValidations () {
      if (this.isEditValidation) {
        this.updateValidation()
      } else {
        this.addFieldValidation()
      }
    },
    updateValidation () {
      console.log('save valdition')
      let params = {
        validation_name: this.editValidationName,
        error_message: this.editErrorMessage,
        rules: JSON.parse(this.editRule),
        is_optional: this.isOptional
      }
      Vue.axios.patch('/settings/custom_validations/' + this.editedValidation.id, params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let result = res.data
          console.log(result)
          this.isEditValidation = false
          this.editErrorMessage = ''
          this.editRule = ''
          this.editValidationName = ''
          this.showVersionsRow = true
          this.isOptional = false
          this.customValidations.map((validation) => {
            if (validation.id === this.editedValidation.id) {
              validation['rules'] = JSON.stringify(params.rules)
              validation['error_message'] = params.error_message
              validation['validation_name'] = params.validation_name
              validation['is_optional'] = params.is_optional
            }
            return validation
          })
          // this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    editCustomValidation (index, validation) {
      console.log(index)
      console.log(validation)
      this.isEditValidation = true
      this.editedValidation = validation
      this.editRule = validation.rules
      this.editErrorMessage = validation.error_message
      this.editValidationName = validation.validation_name
      this.isOptional = validation.is_optional
    },
    showDeleteModal (templateDocId) {
      this.template_doc_id = templateDocId
      this.$refs['deleteModal'].show()
    },
    cancel () {
      this.$refs['deleteModal'].hide()
    },
    onHidingExtSerValModal () {
      this.resetData()
    },
    resetData () {
      this.availableTemplates = []
      this.availableTemplateVersions = []
      this.selectedTemplate = null
      this.selectedTemplateVersion = null
      this.showVersionsRow = false
      this.showESV = false
      this.showFetchButton = false
      this.extServiceValidation = {
        created: true
      }
      this.templateDoc.tmpFields = []
      this.externalServiceValidation = {
        selectedTmpField: '',
        selectedCondition: '',
        errorMessage: '',
        conditionValue: '',
        externalServiceValidations: []
      }
      this.editRule = ''
      // this.customValidations = []
      this.isEditValidation = false
      this.editRule = ''
      this.editValidationName = ''
      this.editErrorMessage = ''
      this.editedValidation = null
    },
    handleSelectedVersion () {
      this.showESV = false
      this.showFetchButton = true
    },
    fetchData (newValue) {
      this.showVersionsRow = false
      Vue.axios.get('/settings/custom_validations/fetch_templates?template_doc_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          let result = res.data
          this.showVersionsRow = true
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateVersion (newValue) {
      this.showESV = false
      this.selectedTemplateVersion = null
      if (newValue) {
        Vue.axios.get('/settings/custom_validations/fetch_versions?template_id=' + newValue, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            let result = res.data
            this.availableTemplateVersions = [{text: 'Select version', value: null, disabled: true}].concat(result.versions)
          })
          .catch(error => {
            if (error.status === 401) {
              Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            }
          })
      }
    },
    fetchValidations () {
      let validationData = new window.FormData()
      this.isOptional = false
      validationData.append('template_doc_id', this.templateDoc.selectedTemplateDocId)
      validationData.append('template_id', this.selectedTemplate)
      validationData.append('revision_id', this.selectedTemplateVersion)
      Vue.axios.post('/settings/custom_validations/fetch_validations', validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          console.log(response)
          if (response.data.status === 'SUCCESS') {
            this.showFetchButton = false
            let result = response.data
            this.showESV = true
            this.externalServiceValidation.externalServiceValidations = result.external_field_validations
            let lop = result.external_field_validations.map((validation) => {
              validation['rules'] = JSON.stringify(validation['rules'])
              return validation
            })
            this.customValidations = JSON.parse(JSON.stringify(lop))
            Vue.toasted.show(response.data.message)
          } else {
            Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    addFieldValidation () {
      let params = {
        template_doc_id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion,
        rules: JSON.parse(this.editRule),
        validation_name: this.editValidationName,
        error_message: this.editErrorMessage,
        is_optional: this.isOptional
      }
      Vue.axios.post('/settings/custom_validations', params, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.status === 'SUCCESS') {
            let result = response.data.custom_validation
            result['rules'] = JSON.stringify(result['rules'])
            this.customValidations.push(result)
            this.externalServiceValidations = this.externalServiceValidations.filter((key, index) => { console.log(key); console.log(response.data.external_service_validation); return key.template_doc_id !== response.data.external_service_validation.template_doc_id }).concat(response.data.external_service_validation)
            this.editErrorMessage = ''
            this.editRule = ''
            this.editValidationName = ''
            this.isOptional = false
            Vue.toasted.show(response.data.message)
          } else {
            Vue.toasted.show(response.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    editExternalServiceValidation (templateDocId) {
      Vue.axios.get('/settings/custom_validations/' + templateDocId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          let result = response.data
          this.availableTemplates = [{text: 'Select Page', value: null, disabled: true}].concat(result.templates)
          this.availableTemplateVersions = [{text: 'Select Versions', value: null, disabled: true}].concat(result.versions)
          this.selectedTemplate = result.templates[0]['value']
          this.selectedTemplateVersion = result.versions[0]['value']
          this.showVersionsRow = true
          this.externalServiceValidation.externalServiceValidations = result.external_field_validations
          this.isOptional = false
          console.log(result)
          this.templateDoc.selectedTemplateDocId = result.template_doc_id
          this.templateDoc.tmpFields = result.template_fields
          this.templateDoc.tmpFields.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0))
          this.showESV = true
          this.$refs.externalServiceValidationModal.show()
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            console.log(error)
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteExternalServiceValidation () {
      let validationData = new window.FormData()
      validationData.append('template_doc_id', this.template_doc_id)
      Vue.axios.post('/settings/custom_validations/delete_template_validations', validationData, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          if (response.data.deleted) {
            this.externalServiceValidations = this.externalServiceValidations.filter((key, index) => { return key.template_doc_id !== this.template_doc_id })
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_DELETE_ERR'), { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    deleteCustomValidation (validationId) {
      Vue.axios.delete('/settings/custom_validations/' + validationId, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.customValidations = this.customValidations.filter((csv, index) => { return csv.id !== validationId })
          Vue.toasted.show('Validation is Deleted')
        })
        .catch(error => {
          if (error.response.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    saveImportValidations () {
      Vue.axios.post('/settings/custom_validations/save_import_validations', this.validationPayload, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.status === 'SUCCESS') {
            Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
            this.$refs.externalCustomImportValidationModal.hide()
            if (!res.data.error) {
              router.go()
            }
          } else {
            Vue.toasted.show(res.data.message, { icon: 'chain-broken', type: 'error' })
          }
        })
        .catch(error => {
          if (error.status === 401) {
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    downloadCsvalidations () {
      let parameters = {
        id: this.templateDoc.selectedTemplateDocId,
        template_id: this.selectedTemplate,
        revision_id: this.selectedTemplateVersion
      }
      Vue.axios.get('/settings/custom_validations/download_csvalidations', { headers: { Authorization: `Bearer ${this.idToken}` }, params: parameters })
        .then(res => {
          this.validationData = res
          const data = JSON.stringify(this.validationData.data.validations)
          const templateName = JSON.stringify(this.validationData.data.template_name).replace(/\s+/g, '_')
          const filename = templateName + '_custom_validations' + '_version' + this.selectedTemplateVersion + '.txt'
          var element = document.createElement('a')
          element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data))
          element.setAttribute('Download', filename)
          element.style.display = 'none'
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(error)
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.vsa-item__trigger:hover {
  background-color: #41b883 !important;
}
.modelSelect /deep/ div.text{
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.delete-warning {
  font-size : 1rem;
  color: red;
}
.card {
  background: #ebeff3;
  border-radius: 10px;
}
.card-header {
  background: #f7f7f7;
}
.temp_mapping {
  background: #f8f9fa;
  padding: 0.5rem;
  margin: 0;
}
.external-service-modal {
  .row {
    margin-bottom: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settings/customValidations.vue